theme.ajaxCart = function(){
  function wishlist() {
    var cookieName = "wishlistList";
    $(".add-to-wishlist").click(function(e){
      e.preventDefault();
      var id = $(this).attr('href');
      if($.cookie(cookieName) == null) {
        var str = id;
      } else {
        if($.cookie(cookieName).indexOf(id) == -1) {
          var str = $.cookie(cookieName) + '__' + id;
        }
      }
      $.cookie(cookieName, str, {expires:30, path:'/'});
      $(this).find(".ad-spin").css('display','inline-block');
      $(this).find(".ad-heart-l").hide();
      setTimeout(function(){
        $('.add-to-wishlist[rel="'+id+'"]').hide();
        $('.added-wishlist[rel="'+id+'"]').css('display','inline-block');
      }, 2000);
    })
  }
  function updateWishlist() {
    var cookieName = "wishlistList";
    try {
      if($.cookie(cookieName) != null && $.cookie(cookieName) != '__' && $.cookie(cookieName) != '') {
        var str = String($.cookie(cookieName)).split("__");
        for (var i=0; i<str.length; i++) {
          if (str[i] != '') {
            $('.added-wishlist[rel="'+str[i]+'"]').css('display','inline-block');
            $('.add-to-wishlist[rel="'+str[i]+'"]').hide();
          }
        }
      }
    }
    catch (err) {}
  }
};

$(document).ready(function(){
  //check if any swatches exist
  if($('.color-swatch-custom').length > 0 ){
    const swatches = $('.color-swatch-custom');


  //on every swatch click
    swatches.click(function(e){
      var dataSwatch = e.target.getAttribute('data-variant-id');

      //trigger change to the select which is already invisible, to make cart button work
      $('select[name="id"]')
      .val(dataSwatch)
      .trigger('change');
    })

  }

  $('.quick-links').flickity({
    // options
    cellAlign: 'center',
    contain: true,
    groupCells: true
  });

  var tabs = this.tabs = '.tabs-listing' + ' .tablink';

  $(tabs).on('click', function(e){

  e.preventDefault();
  e.stopPropagation();

  $(this).parent().addClass("active");
    $(this).parent().siblings().removeClass("active");

    var tab = $(this).attr("href");
    $(".tab-content").not(tab).css("display", "none");

    $(tab).fadeIn();

    /*if($(window).width()<767) {
      var tabposition = $(this).offset();
      $("html, body").animate({ scrollTop: tabposition.top }, 700);
    }*/

    return false;
  });

  $('.product-tabs li:first-child').addClass("active");
  $('.tab-container h3:first-child + .tab-content').show();

  if ( window.innerWidth <= 425 ) {
    $(".header__action-item--account.hidden-tablet-and-up").insertAfter( $(".header__action-item--cart") )

    $("#shopify-section-1570016462074").insertBefore( $("#shopify-section-1570016343622") )

    $('.quick-links').flickity({
      groupCells: 3
    });

    //$(".collection__toolbar-item--sort").insertBefore( $(".collection__toolbar-item--filter") )

    $("#sort-content .value-picker-button").click(function(){
      $("#sort-content").addClass("open-true");
    });
    $(".value-picker__close").click(function(){
      $("#sort-content").removeClass("open-true");
    });

    $(".vendor-image").insertBefore( $(".product-gallery") )

  }


  /* REGISTER PAGE */
  if( window.location.pathname == '/account/register' ){

      var customerBirthdate = document.getElementById('customerBirthdate');
        var customerBirthdateValue = document.getElementById('customerBirthdateValue');
        var customerId = document.getElementById('customerId');
    var customerIdValue = document.getElementById('customerIdValue');


      document.querySelector('input[type="date"]').nextElementSibling.style.marginTop = '-6px';
      document.getElementById('document_type').nextElementSibling.style.marginTop = '-8px';

      customerId.addEventListener( 'keyup' , function( e ){
      customerIdValue.value = 'document='  + e.target.value;
    })

    customerBirthdate.addEventListener( 'keyup' , function( e ){
      customerBirthdateValue.value = 'birthdate='  + e.target.value;
    })



        $(document).ready(function(){

          var customerAddress = document.getElementById('setAddress')
          var customerAddressValue = document.getElementById('setAddressValue')

          customerAddress.addEventListener( 'keyup' , function( e ){
            customerAddressValue.value = 'address='  + e.target.value;
          })

          $('#defa_depa').text("Cargando departamentos")
          $.getJSON('https://innovateshopifyapps.com/inverfin/carrier-service/departament', data => {
            console.log(data);
            var filter = {
              departament: {
                id: '',
                name: ''
              },
              city: {
                id: '',
                name: ''
              },
              neighborhood: {
                id: '',
                name: ''
              }
            };
            for(i in data){
              let html = `<option value="${data[i]['a:codigoDepartamento']}">${data[i]['a:descripcionDepartamento']}</option>`

              $('#setDepartament').append(html);
            }
            $('#defa_depa').text("Selecciona una opción")

            $('#setDepartament').change(function() {
              $('#setCity').html("<option id='prevent_city' disabled selected>Cargando ciudades...</option>");
              $('#setNeighborhood').html("<option id='prevent_barrio' disabled selected>Seleccione una ciudad</option>");
              filter.departament.id = '';
              filter.departament.name = '';
              var depaSelectedId = $(this).children("option:selected").val()
              var depaSelectedName = $(this).children("option:selected").text()
              filter.departament.id = depaSelectedId;
              filter.departament.name = depaSelectedName;
              $('#setDepartamentValue').val(`departamentId=${depaSelectedId}`);
              $('#setDepartamentName').val(`departamentName=${depaSelectedName}`);

              $('#setCityValue').val('');
              $('#setCityName').val('');

              $('#setNeighborhoodValue').val('');
              $('#setNeighborhoodName').val('');

              console.log(filter)
              $.getJSON(`https://innovateshopifyapps.com/inverfin/carrier-service/city?departament_code=${escape(depaSelectedId)}`, data => {
                for(j in data){
                  let html = `<option value="${data[j]['a:codigoCiudad']}">${data[j]['a:descripcionCiudad']}</option>`

                  $('#setCity').append(html);

                }
                $('#prevent_city').text("Seleccione su ciudad")
              })

            });
            $('#setCity').change(function() {
              $('#setNeighborhood').html("<option id='prevent_barrio' disabled selected>Cargando barrios...</option>");
              filter.city.id = '';
              filter.city.name = '';
              var citySelectedId = $(this).children("option:selected").val()
              var citySelectedName = $(this).children("option:selected").text()
              filter.city.id = citySelectedId;
              filter.city.name = citySelectedName;
              $('#setCityValue').val(`cityId=${citySelectedId}`);
              $('#setCityName').val(`cityName=${citySelectedName}`);

              $('#setNeighborhoodValue').val('');
              $('#setNeighborhoodName').val('');

              console.log(filter)
              $.getJSON(`https://innovateshopifyapps.com/inverfin/carrier-service/neighborhood?code_city=${escape(citySelectedId)}`, data => {
                for(k in data){
                  let html = `<option value="${data[k]['a:codigoBarrio']}">${data[k]['a:descripcionBarrio']}</option>`

                  $('#setNeighborhood').append(html);
                }
                $('#prevent_barrio').text("Seleccione su barrio")
              })
            })
            $('#setNeighborhood').change(function() {
              filter.neighborhood.id = '';
              filter.neighborhood.name = '';
              var barrioSelectedId = $(this).children("option:selected").val()
              var barrioSelectedName = $(this).children("option:selected").text()
              filter.neighborhood.id = barrioSelectedId;
              filter.neighborhood.name = barrioSelectedName;
              $('#setNeighborhoodValue').val(`barrioId=${barrioSelectedId}`);
              $('#setNeighborhoodName').val(`barrioName=${barrioSelectedName}`);
              console.log(filter)
            })


          }
                   );

        })



  }

  // $(".btn-credito").click(function(){
  //   $("#credito-popup").removeClass("d-none");
  // });

  // $('.close').click( function() {
  //   $('#credito-popup').addClass("d-none");
  // });


  $('.slider-recommendations').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


  /**** Check Ajax Cart contains Moto ****/

  // Select the node that will be observed for mutations
  const targetNode = document.getElementById('mini-cart');
  const targetNodeBtn = document.querySelector('a.header__action-item-link.hidden-pocket.hidden-lap')
  var targetCash = document.querySelector(".product-form__info-content")
  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true };
  // Callback function to execute when mutations are observed
  const callback = function(mutationsList, observer) {
    // Use traditional 'for loops' for IE 11
    for(let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        //checkPrice()
        //console.log('A child node has been added or removed.');
      }
      else if (mutation.type === 'attributes') {
        if( mutation.attributeName == 'aria-hidden'){
      checkIsMoto()
            //console.log('A child node has been added or removed.');
    }
      }
    }
  };
  
  if ( targetNode ){

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
    observer.observe(targetNodeBtn, config);
    //observer.observe(targetCash, config);

    var checkoutButton = document.querySelector('#mini-cart > div > div.mini-cart__recap > div.mini-cart__button-container > div > button');
  }
  function checkIsMoto(){

  var process = setInterval(function(){
      var text = document.querySelector('#mini-cart').innerText.toLowerCase();
    if( text != '' ){
        document.querySelector('#mini-cart > div > div.mini-cart__recap > div.mini-cart__button-container > div > button').style.display = 'none';

    /*if( text.match('\\bmoto\\b') != null || text.match('\\bmotoneta\\b') != null ){
      //console.log( 'Estoy en el true' )
            document.querySelector('#mini-cart > div > div.mini-cart__recap > div.mini-cart__button-container > div > button').style.display = 'none';
    }else{
      //console.log( 'Estoy en el false' )
            document.querySelector('#mini-cart > div > div.mini-cart__recap > div.mini-cart__button-container > div > button').style.display = 'block';
        }*/
        clearInterval(process);
    }

    }, 100);


  }

  function checkPrice(){
    if( localStorage.getItem('changePrice') == null ){
  var process = setInterval(function(){
      var cash = $('#product_form_4425348874295 > div.product-form__info-list > div:nth-child(1) > div > div.price-list > span.price.price--highlight');
    if( cash.text() != '' ){
        localStorage.setItem('changePrice','1')
        var text = cash.text()
        text = text.replace( 'Gs. ' , '' )
        text = text.replace( ',' , '' )
        text = text.replace( '.' , '' )
    console.log( text )
        var itemPrice = parseInt( text ) * 10000;
        console.log( itemPrice )
    cash.text(Shopify.formatMoney(itemPrice, theme.moneyFormat))
        clearInterval(process);
      }else{
        clearInterval(process);
      }

    }, 100);

    }
  }

  /**** End Check Ajax Cart contains Moto ****/

  /** Change Swacth Color an Thumbail Image **/
  variantSelector = jQuery('.product-form__option');
  imgList = jQuery('.product-gallery__thumbnail-list');

  if( variantSelector.length > 0 ){
    variantSelector.change(function(){

      setTimeout(function(){
        let variant1 = jQuery('span[class="product-form__selected-value"]').text();
        var imgId = jQuery('input[value="'+variant1+'"]').attr("data-image-id");
        jQuery('div[data-image-id="'+imgId+'"]').trigger('click')

    var cash = $('#product_form_4425348874295 > div.product-form__info-list > div:nth-child(1) > div > div.price-list > span.price.price--highlight');
        var compare = $('#product_form_4425348874295 > div.product-form__info-list > div:nth-child(1) > div > div.price-list > span.price.price--compare');

         if( cash.text() != '' ){
          var text = cash.text()
          text = text.replace( 'Gs. ' , '' )
          text = text.replace( ',' , '' )
            text = text.replace( '.' , '' )
          var itemPrice = parseInt( text ) * 10000;
            if( itemPrice.toString().length == 8 ){
        itemPrice = itemPrice * 10
      }
      cash.text(Shopify.formatMoney(itemPrice, theme.moneyFormat))
     }

          if( compare.text() != '' ){
          var text = compare.text()
          text = text.replace( 'Gs. ' , '' )
          text = text.replace( ',' , '' )
            text = text.replace( '.' , '' )
          var itemPrice = parseInt( text ) * 10000;
            if( itemPrice.toString().length == 8 ){
        itemPrice = itemPrice * 10
      }
      compare.text(Shopify.formatMoney(itemPrice, theme.moneyFormat))
     }
      },200)

    });

    imgList.click(function(e){
      var img = e.target.parentElement.parentElement.getAttribute('data-image-id')
      setTimeout(function(){
        jQuery('input[data-image-id="'+img+'"]').trigger('click');

    //cash.text(Shopify.formatMoney(itemPrice, theme.moneyFormat));
      },200)

    });
  }
  /** End Change Swacth Color an Thumbail Image **/

  $('.ref-btn').click( function() {
    $('.ref-content').css('height','auto');
  });


  if( document.querySelector('a.header__action-item-link.hidden-pocket.hidden-lap').nextElementSibling != null ){
    document.querySelector('a.header__action-item-link.hidden-pocket.hidden-lap').nextElementSibling.children[1].children[0].children[1].innerText = 'Mis Datos';
    document.querySelector('a.header__action-item-link.hidden-pocket.hidden-lap').nextElementSibling.children[1].children[0].children[1].setAttribute( 'href' , '/pages/profile' );
  }


  //


  // register validations
  var curUrl = window.location.href

  if ( curUrl.includes('register') ) {


    function extra_validations(target, action){
      if ( target ) {
          if ( action == 'acentos' ) {
            target.value = target.value.replace('&','y')
            target.value = target.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            target.value = target.value.replace(' ','')
          }
      }
    }

    setInterval(function(){
      var customerId = document.getElementById("customerId")
      extra_validations( customerId, "acentos" );
    }, 2000);

  }





});



/**** REORDER PRICE LIST IN SIDEBAR FILTERS ****/
document.addEventListener("DOMContentLoaded", function() {
    if( document.querySelectorAll('li[data-tag*="precio_"]').length != 0 ){

        const [...all_li]    = document.querySelectorAll('li[data-tag*="precio_"]');
        const container      = document.querySelectorAll('li[data-tag*="precio_"]')[0].parentElement
      const [...container_childrens] = container.children;
        all_li.sort( sortFunc )

        container_childrens.forEach( ( item , index ) => {
            container.insertBefore( all_li[index] , item[index])
        })

    }

});

function sortFunc(a, b) {
    var sortingArr = [ 'precio_menos-de-gs-500-000', 'precio_gs-500-001-gs-3-000-000', 'precio_gs-3-000-001-gs-6-000-000', 'precio_gs-6-000-001-gs-10-000-000', 'precio_mas-de-gs-10-000-000'];
    return sortingArr.indexOf(a.getAttribute('data-tag')) - sortingArr.indexOf(b.getAttribute('data-tag'));
}
/**** END REORDER PRICE LIST IN SIDEBAR FILTERS ****/


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.addEventListener('DOMContentLoaded', (event) => {
  if ( window.location.href.includes('/cart') ) {
    const buttonShipping = document.querySelector('.estimate-shipping__toggle');
    const buttonNota = document.querySelector('.cart-recap__note-button');
    const divNota = document.getElementById('order-note');
    const divShipping = document.getElementById('shipping-estimator-creative');

    
    buttonShipping.addEventListener( btn => {
      if ( divShipping.style.overflow == "hidden" ) {
        divShipping.style.padding = '18px';
      } else {
        divShipping.style.padding = '';
      }
    });
    
    buttonNota.addEventListener( btn => {
      if ( divNota.style.overflow == "hidden" ) {
      	divNota.style.padding = '18px';
      } else {
      	divNota.style.padding = '';
      }
    	
    });

  }
})